import React from "react";
import classNames from "classnames";
import { AvatarProps, Avatar as DefaultAvatar } from "stream-chat-react";
import type { StreamMessage } from "stream-chat-react";
import type { DefaultStreamChatGenerics } from "stream-chat-react";
import type { TimestampFormatterOptions } from "stream-chat-react";

type CustomSystemMessageProps<
  StreamChatGenerics extends DefaultStreamChatGenerics = DefaultStreamChatGenerics
> = TimestampFormatterOptions & {
  message: StreamMessage<StreamChatGenerics>;
  Avatar?: React.ComponentType<AvatarProps>;
};

export const SystemMessage = <
  StreamChatGenerics extends DefaultStreamChatGenerics = DefaultStreamChatGenerics
>(
  props: CustomSystemMessageProps<StreamChatGenerics>
) => {
  const { Avatar = DefaultAvatar, message } = props;
  const { event, text, type } = message;

  if (type === "system") {
    return (
      <div
        className={classNames(
          "str-chat__message--system t-text-center t-text-text-60 t-p-3 t-rounded-lg t-bg-[#EDECF0] t-mt-2"
        )}
        data-testid="message-system"
      >
        <div className="str-chat__message--system__text">
          <div className="str-chat__message--system__line t-bg-neutral-70" />
          <p className="t-text-body-sm">{text}</p>
          <div className="str-chat__message--system__line t-bg-neutral-70" />
        </div>
      </div>
    );
  }

  if (event?.type === "member.removed" || event?.type === "member.added") {
    const name = event.user?.name || event.user?.id;
    const sentence = `${name} ${
      event.type === "member.added"
        ? "has joined the chat"
        : "was removed from the chat"
    }`;

    return (
      <div
        className={classNames(
          "str-chat__event-component__channel-event t-flex t-items-center t-gap-3 t-text-text-60 t-p-3 t-rounded-lg t-bg-[#EDECF0] t-mt-2"
        )}
      >
        <Avatar image={event.user?.image} name={name} user={event.user} />
        <div className="str-chat__event-component__channel-event__content t-flex t-flex-col">
          <em className="str-chat__event-component__channel-event__sentence t-text-body-sm">
            {sentence}
          </em>
        </div>
      </div>
    );
  }

  return null;
};
